import React from 'react';
import EventNote from './EventNote';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'event-note';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <EventNote
        key={`${type}-${index}`}
        note={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
